import "core-js/modules/es.object.keys.js";
import React from 'react';
import { useCountries } from '@applyboard/business-ui-legacy';
import Table from "../../Table";
var AgentContent = function AgentContent(props) {
  var _props$application;
  var _useCountries = useCountries(),
    countryToCodeMapping = _useCountries.countryToCodeMapping;
  var agent = (_props$application = props.application) !== null && _props$application !== void 0 && _props$application.agent && Object.keys(props.application.agent).length > 0 ? props.application.agent : null;
  if (!agent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Table, {
    info: [{
      name: 'Email',
      value: agent.email
    }, {
      name: 'Company',
      value: agent.company_name
    }, {
      name: 'Phone Number',
      value: agent.phone
    }, {
      name: 'Country',
      value: countryToCodeMapping === null || countryToCodeMapping === void 0 ? void 0 : countryToCodeMapping[agent.country]
    }]
  });
};
export default AgentContent;